import { logos } from "@resourcehub/resourcehub-assets";

export default ({ strings }) => [
    {
        name: strings.branded_quotes_macworld_name,
        type: strings.branded_quotes_macworld_type,
        quote: strings.branded_quotes_macworld_quote,
        logo: {
            asset_static: logos.logoMacworldSvg
        },
        backdrop: logos.logoMacworldBgSvg
    },
    {
        name: strings.branded_quotes_techcrunch_name,
        type: strings.branded_quotes_techcrunch_type,
        quote: strings.branded_quotes_techcrunch_quote,
        logo: {
            asset_static: logos.logoTechcrunchSvg
        },

        backdrop: logos.logoTechcrunchBgSvg
    },
    {
        name: strings.branded_quotes_cnn_name,
        type: strings.branded_quotes_cnn_type,
        quote: strings.branded_quotes_cnn_quote,
        logo: {
            asset_static: logos.logoCnnSvg
        },
        backdrop: logos.logoCnnBgSvg
    }
];
